import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  Modal,
  Container,
  Title,
  ButtonSave,
  ButtonCancel,
  ContainerBottom,
  TextArea,
  Form,
  FormField,
} from './styles';

const WriteFeedbackModal = (props) => {
  const {
    onSubmit,
    testSession,
    onClose,
    open,
  } = props;

  const {
    feedback,
    id,
  } = testSession;

  const [newFeedback, setNewFeedback] = useState('');

  useEffect(() => {
    setNewFeedback(feedback);
  }, [feedback]);

  const handleChangeFeedback = (e, { value }) => {
    setNewFeedback(value);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
    >
      <Container>
        <Title>Write feedback</Title>
        <Form>
          <FormField>
            <TextArea
              value={newFeedback}
              onChange={handleChangeFeedback}
            />
          </FormField>
        </Form>

        <ContainerBottom>
          <ButtonCancel
            onClick={onClose}
          >
            Cancel
          </ButtonCancel>
          <ButtonSave
            onClick={() => onSubmit(id, newFeedback)}
          >
            Save
          </ButtonSave>
        </ContainerBottom>
      </Container>
    </Modal>
  );
};

WriteFeedbackModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  testSession: PropTypes.shape({
    id: PropTypes.string,
    feedback: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

WriteFeedbackModal.defaultProps = {
  testSession: {},
  open: false,
};

export default WriteFeedbackModal;
